import { ListItem, ListItemText, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import { Box, List } from "@mui/material";
import useSession from "hooks/call-queue/useSession";
import useApi from "hooks/useApi";
import useFirebase from "hooks/useFirebase";
import { CallStatus, ISupportUserListItem } from "types/auth";

const InviteSupportUser = ({ supportUsers, handleClose }: { supportUsers: ISupportUserListItem[], handleClose: () => void }) => {
    const theme = useTheme();
    const { session } = useSession();
    const { user, showToast, inviteSupportUser } = useApi();
    const { addCallToUser, updateRecipients, updateSessionTokens, removeUserUidFromTo, updateUserCallStatus } = useFirebase();

    const onClickItem = async (userUid: string) => {
        if(userUid == user.uid){
            showToast('You are already on call', 'info');
        }else{
            try{
                let response = await inviteSupportUser(session?.transaction!, userUid);
                let { success, data, message } = response;
                if(success){
                    addCallToUser(session?.transaction!, userUid, CallStatus.CALLING, 'SUPPORT');
                    updateRecipients(session?.transaction!, [...session?.recipients ? session?.recipients : [], userUid]);
                    updateSessionTokens(session?.transaction!, data);
                    handleClose();
                    setTimeout(() => {
                        let invitedUser = session?.to.find(f => f.user == userUid);
                        if(invitedUser && ![CallStatus.IN_PROGRESS, CallStatus.COMPLETED].includes(invitedUser.status)){
                            removeUserUidFromTo(session?.transaction!, userUid);
                            let recipients = [...session?.recipients ? session?.recipients : []]
                            recipients = recipients.filter(recipient => recipient != userUid);
                            updateRecipients(session?.transaction!, recipients);
                            updateUserCallStatus(session?.transaction!, userUid, CallStatus.MISSED_CALL)
                        }
                    }, 30 * 1000)
                }else{
                    showToast(message, 'error');
                }
            } catch(error: any){
                showToast(error.message, 'error');
            }
        }
    }

    return (
        <Box sx={{ width: '250px', maxHeight: '350px' }}>
            <List sx={{ width: '100%', maxWidth: '250px', maxHeight: '350px', bgcolor: 'background.paper' }}>
                {
                    supportUsers.length == 0 && (
                        <ListItem key={`item-empty`}>
                            <ListItemText primary={`No Users Found`} />
                        </ListItem>
                    )
                }
                {
                    supportUsers.map(supportUser => {
                        return (
                            <ListItem
                                onClick={() => {
                                    onClickItem(supportUser.uid);
                                }}
                                sx={{ cursor: 'pointer' }}
                                key={`item-${supportUser.uid}`}
                                secondaryAction={
                                    supportUser.uid == user.uid && (
                                        <Box sx={{ background: theme.palette.primary.main, padding: '2px 10px', borderRadius: '10px' }}>
                                            <Typography color="#fff">You</Typography>
                                        </Box>
                                    )
                                }
                            >
                                <ListItemText primary={`${supportUser.firstName} ${supportUser.lastName}`} secondary={supportUser.role} />
                            </ListItem>
                        )
                    })
                }
            </List>
        </Box>
    )
}

export default InviteSupportUser;